export const MONITORING_REPORTS = {
    "SET_DATA_AVERAGE": "SET_DATA_AVERAGE",
    "SET_CARD_DATASET": "SET_CARD_DATASET",
    "NEXT_YEAR": "NEXT_YEAR",
    "PREV_YEAR": "PREV_YEAR"
}